import axios from 'axios';
import _ from 'lodash';
import { helperGetApiHeaders, helperGetApiRouteById, axiosErrorHandler } from 'helpers/ApiHelper';
import { setVideoPanel as setGlobalVideoPanel } from 'components/VideoPlayerGlobal/Actions';
import { PAGE_WATCH } from 'helpers/PageHelper';
import { LOCAL_CLIP_PAGE_COOKIE_NAME } from 'helpers/ContentHelper';
import { getCookie } from 'helpers/Storage';
import { fetchFooter } from 'components/Footer/FooterActions';

export const CLEAR_WATCH = 'CLEAR_WATCH';
export const FETCH_MOVIE_DETAIL = 'FETCH_MOVIE_DETAIL';
export const FETCH_WATCH = 'FETCH_WATCH';
export const FETCH_WATCH_ERROR = 'FETCH_WATCH_ERROR';
const FETCH_WATCH_PANELS = 'FETCH_WATCH_PANELS';
export const SET_WATCH_PANELS = 'SET_WATCH_PANELS';
export const SET_NEXT_PAGE = 'SET_NEXT_WATCH_PAGE';

export function fetchWatch(id, accessToken, deviceId) {
  const pageType = 'videoDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(axiosErrorHandler);

  return {
    type: FETCH_WATCH,
    payload: request,
  };
}

function setWatchPanels(data) {
  return {
    type: SET_WATCH_PANELS,
    payload: data,
  };
}

export const fetchWatchPanels = (
  id,
  accessToken,
  deviceId,
  doNotSetGlobalVideoPanel,
  optimizelyProps,
) => dispatch => {
  dispatch({ type: FETCH_WATCH_PANELS });
  const pageType = 'videoDetail';
  return axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .then(results => {
      // to allow quick render set panels before fetching pagination
      const panels = _.get(results, 'data.panels.member');
      const firstPanel = _.get(panels, '0');
      if (!firstPanel) throw new Error('404');
      const optimizelyResults = optimizelyProps?.callback(_.get(firstPanel, 'items.member.0'));
      dispatch(setWatchPanels(results));
      if (doNotSetGlobalVideoPanel) return;
      const localPlayerScreenUrl = getCookie({ name: LOCAL_CLIP_PAGE_COOKIE_NAME });
      if (localPlayerScreenUrl) {
        firstPanel.items.member[0].playerScreenUrl = localPlayerScreenUrl;
      }
      dispatch(setGlobalVideoPanel({ panel: firstPanel, source: PAGE_WATCH, optimizelyResults }));
    })
    .catch(errors => {
      axiosErrorHandler(errors);
      dispatch({ type: FETCH_WATCH_ERROR, payload: errors });
    })
    .then(() => dispatch(fetchFooter()));
};

export function fetchMovieDetail(id, accessToken, deviceId) {
  const pageType = 'movieVideoDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(axiosErrorHandler);

  return {
    type: FETCH_MOVIE_DETAIL,
    payload: request,
  };
}

export function clearWatch() {
  return {
    type: CLEAR_WATCH,
  };
}
